import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axios/axios.js";

export const generateHashtags = createAsyncThunk(
  "/api/v1/ai/generateTrendingHashtags", 
  async (comment) => {
    const response = await axios.post("/api/v1/ai/generateTrendingHashtags", { comment });
    return response.data; 
  }
);

const GenerateHashtagSlice = createSlice({
  name: "GenerateHashtag",
  initialState: {
    hashtags: "", 
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(generateHashtags.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateHashtags.fulfilled, (state, action) => {
        state.loading = false;
        state.hashtags = action.payload.data.hashtags;  
      })
      .addCase(generateHashtags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default GenerateHashtagSlice.reducer;
